<template>
    <div class="d-flex flex-column">
        <order-price
            v-if="!isAgency && !$conf.public.account.licenseeForCorporateCompany && !isStaticPackage"
            :title="isTourOperator ? 'client_price' : null"
            :subtitle="isStaticPackage ? 'part_of_package' : null"
            :price="clientPrice"
            :payment-status="customerPaymentStatus"
            :cancel-penalties="clientCancelPenalties"
            :show-commission="isTourOperator"
            :loyalty-points="isB2C ? loyaltyPoints : null"
            :service-card-guarantee="serviceCardGuarantee"
            :service="service"
            :hide-cancel-penalties="isBankFee"
            :discount="clientDiscount"
            _data-cy="client-price"
        >
            <slot name="violation" />
        </order-price>
        <!-- ZSH: Supplier price block commented out (per-service price column in OrderInfoBase,
             left of the Voucher/Cancel buttons). Only the Client price block is shown.
        <div v-if="isTourOperator || isAgency">
            <v-divider v-if="commissionAndNettoCheckbox && !isStaticPackage" class="mt-2 pb-2" />
            <order-price
                v-if="commissionAndNettoCheckbox"
                :title="isAgency ? 'price' : 'supplier_price'"
                :price="supplierPrice"
                :payment-status="supplierPaymentStatus"
                :cancel-penalties="supplierCancelPenalties"
                :show-commission="true"
                :loyalty-points="loyaltyPoints"
                :service-card-guarantee="serviceCardGuarantee"
                :service="service"
                :discount="supplierDiscount"
                :hide-cancel-penalties="isBankFee"
                _data-cy="supplier-price"
                show-pricing-source-type
            >
                <template v-slot:income>
                    <v-row v-if="isTourOperator && income?.amount && !isStaticPackage" no-gutters>
                        <v-divider class="mt-2 pb-2" />
                        <div class="commission-block full-width">
                            <span class="text-body-2">
                                {{ $t('income') }}
                            </span>
                            <div class="text-end">
                                <p class="text-green text-subtitle-1 font-weight-medium">
                                    {{ income.amoun > 0 ? '+' : '' }}
                                    {{ $filters.priceFormat(income.amount, income.currency) }}
                                </p>
                                <p v-if="income?.percent" class="text-body-2 text-medium-emphasis">
                                    {{ `${income.percent}%` }}
                                </p>
                            </div>
                        </div>
                    </v-row>
                </template>
            </order-price>
        </div>
        -->
    </div>
</template>

<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import {OrderPrices as _OrderPrices} from '~src/components/account/snippets/OrderPrices.vue'
    import OrderPrice from '~src/components/account/snippets/orderPrice.src'

    // ZSH: mixin-extends the core class (inherits all props/getters) and provides a custom
    // template with the Supplier price block commented out — only the Client price block
    // renders in the per-service price column. Core behavior unchanged for other builds.
    @Component({components: {OrderPrice}})
    export class OrderPrices extends _OrderPrices {}

    export default {...toNative(OrderPrices)}
</script>

<style scoped>
    .width-50 {
        width: 50%;
    }
    :deep(.commission-block) {
        font-size: 12px !important;
    }
    :deep(.payment-status-label) {
        font-size: 12px !important;
    }
    :deep(.conditions-label) {
        max-width: none;
    }
</style>
